import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Globe, Instagram, MapPin, Phone } from 'lucide-react';
export function Footer() {
  const {
    t
  } = useLanguage();
  return <footer className="bg-ocean-dark text-white pt-16 pb-8" data-id="element-63">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-64">
        <div className="max-w-md" data-id="element-65">
          <img src="https://cdn.magicpatterns.com/uploads/aifgHKgDB7GaFaemiHaRod/LOGO_PNG_ORIGI.png" alt="Blu Ocean Tours" className="h-20 w-auto object-contain mb-4 -ml-2" data-id="element-66" />
          <p className="text-gray-300 mb-5 text-sm leading-relaxed" data-id="element-67">
            {t.footer.privateTours}
          </p>
          <div className="flex items-center gap-2 text-gray-300 text-sm mb-3" data-id="element-68">
            <MapPin size={16} className="text-turquoise" data-id="element-69" />
            <span data-id="element-70">{t.footer.locationBoat}</span>
          </div>
          <a href="tel:+17876722300" className="flex items-center gap-2 text-gray-300 text-sm mb-3 hover:text-white transition-colors" data-id="element-71">
            <Phone size={16} className="text-turquoise" data-id="element-72" />
            <span data-id="element-73">+1 (787) 672-2300</span>
          </a>
          <a href="https://bluoceantours.com/booking/" target="_blank" rel="noreferrer" className="flex items-center gap-2 text-gray-300 text-sm mb-3 hover:text-white transition-colors" data-id="element-74">
            <Globe size={16} className="text-turquoise" data-id="element-75" />
            <span data-id="element-76">bluoceantours.com/booking</span>
          </a>
          <a href="https://www.instagram.com/bluoceantours/" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 text-gray-300 text-sm hover:text-white transition-colors" data-id="element-77">
            <Instagram size={16} className="text-turquoise" data-id="element-78" />
            <span data-id="element-79">@bluoceantours</span>
          </a>
        </div>

        <div className="border-t border-white/10 pt-8 mt-12 text-sm text-gray-400" data-id="element-80">
          <p data-id="element-81">
            &copy; {new Date().getFullYear()} Blu Ocean Tours. {t.footer.rights}
          </p>
        </div>
      </div>
    </footer>;
}